module.exports = __webpack_public_path__ + "img/sledge-hammer.2c241d77.jpg";